export default "__VITE_ASSET__CSuCvzvM__"